import React, { useEffect, useState, useRef } from 'react';
import ChatUser from './chat-component/ChatUser';
import BellIcon from '../../assets/images/bell-icon-blue.svg';
import SettingIcon from '../../assets/images/setting-icon-blue.svg';
import SearchIcon from '../../assets/images/SearchIcon.png';
import UserIcon from '../../assets/images/user-icon4.png';
import AddIcon from '../../assets/images/add-icon.svg';
import SendIcon from '../../assets/images/send-icon.svg';
import TextIcon from '../../assets/images/text-icon.svg';
import SmileIcon from '../../assets/images/smile-icon.svg';
import VoiceIcon from '../../assets/images/voice-icon.svg';
import CompanyLogo from '../../assets/images/company-logo.png';
import locationIcon from '../../assets/images/location-icon.svg';
import phoneIcon from '../../assets/images/phone-icon.svg';
import api from '../../services/api';
import endpoints from '../../services/endpoints';
import ReceivedMessage from './chat-component/ReceivedMessage';
import SentMessage from './chat-component/SentMessage';
import Loader2 from '../../components/loader2';
import RatingWhite from '../../components/RatingWhite';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
//import { message } from 'antd';


const TabBusinessResponse = ({ jobId, duplicate }) =>
{

  const [isPopup, setIsPopup] = useState(false);
  const [jobResponse, setJobResponse] = useState([]);
  const [getId, setGetId] = useState(null);
  const [getJobId, setGetJobId] = useState(null);
  const [responseItem, setResponseItem] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [inputValue, setInputValue] = useState('');
  const [sentMessage, setSentMessage] = useState("");
  const [receivedMessage, setReceivedMessage] = useState({});
  const [messagesArray, setMessagesArray] = useState([]);
  const [groupedMessages, setGroupedMessages] = useState({});
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);
  const [receivedQuote, setReceivedQuote] = useState([]);
  const [receivedQuoteItem, setReceivedQuoteItem] = useState({});


  console.log("get job id:", jobId);
  const GetQuoteByJobId = async () =>
  {
    setIsLoading(true);
    try
    {
      const response = await axios.get(`${API_BASE_URL}/api/Jobs/quote?id=${jobId}`);
      const array = response;
      array.reverse();
      setReceivedQuote(array);
      setIsLoading(false);
    } catch (error)
    {
      setIsLoading(false);
      setError(error.message);
    } finally
    {
      setIsLoading(false);
    }
  }


  // const getAllResponse = async (id) => {
  //   try {
  //     const response = await api.get(endpoints.getAllJobResponseByJobId + id);

  //     setJobResponse(response);
  //     setIsLoading(false);

  //     const grouped = response.reduce((acc, resmessage) => {
  //       const { businessId } = resmessage;
  //       if (!acc[businessId]) acc[businessId] = [];
  //       acc[businessId].push(resmessage);
  //       return acc;
  //     }, {});

  //     setGroupedMessages(grouped);

  //   } catch (error) {
  //     setIsLoading(false);
  //     setError(error.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };



  const handleJobClick = (id, data) =>
  {
    setMessagesArray([]);
    setGetId(id);
    setGetJobId(data?.jobId);
    setResponseItem(data);
    // getResponseMes/sageById(getId);
    setReceivedQuoteItem(data);
    addMessageToChat(data?.message, 'received');

    // setQuotesData(quotesInitial);
    console.log("res iterm", responseItem);
    console.log("get job response", getJobId);
  };

  const handleInputChange = (event) =>
  {
    const value = event.target.value;
    setInputValue(value);
    setSentMessage(value);
    console.log("input value", value);
  };

  const SendMessageResponse = async () =>
  {
    const body = {
      id: 0,
      jobId: responseItem?.jobId,
      businessId: responseItem?.businessId,
      message: sentMessage
    }
    console.log("message Array", messagesArray);
    console.log("message Array", sentMessage);
    console.log("get job response2", groupedMessages);

    setInputValue('');                   // Reset the input field
    setSentMessage('');

    if (sentMessage == "")
    {
      setErrorMsg("Please enter a message.");
    } else
    {
      setErrorMsg("");
      try
      {
        const response = await api.post(endpoints.sendResponse + jobId + '/responses', body);
        // setJobResponse(response);
        addMessageToChat(sentMessage, 'sent');
        setIsLoading(false);
        setSentMessage("");
      } catch (error)
      {
        setIsLoading(false);
        setError(error.message);
      } finally
      {
        setIsLoading(false);
      }
    };

  }


  const getResponseMessageById = async (id) =>
  {
    try
    {
      const response = await api.get(endpoints.getBusinessResponseById + id);
      setReceivedMessage(response);
      setIsLoading(false);
      addMessageToChat(response.message, 'received');
    } catch (error)
    {
      setIsLoading(false);
      setError(error.message);
    } finally
    {
      setIsLoading(false);
    }
  };

  const addMessageToChat = (message, type) =>
  {
    setMessagesArray(prevMessages => [
      ...prevMessages,
      { message, type, id: Date.now() }, // unique id for each message
    ]);
  };


  const OnOpenPopup = () =>
  {
    setIsPopup(true);
  }


  useEffect(() =>
  {
    setIsLoading(true);
    // Fetch data using the Axios instance
    GetQuoteByJobId();

    // getAllResponse(10);

    // console.log("get job response", jobResponse);


  }, []);


  return (
    <>
      <div className='tab-content-wrap'>
        <div className='tab-content'>
          <div className="view-job-section" style={{ width: '100%', padding: "80px 200px" }}>

            <div className='view-chat-list-content' style={{ width: '300px' }} >
              <div>
                <div className='view-chat-list-content-header mb-4'>
                  <p className='view-job-title-p'>Conversation</p>
                  <div className='view-job-search'>
                    <input type="text" placeholder="Enter Keyword" className="search-input" />
                    <img src={SearchIcon} alt='Search' className='search-icon' />
                  </div>

                </div>

                <div>
                  <div className='view-chat-list'>
                    {isLoading && <Loader2 />}
                    {!isLoading && (
                      <div >
                        {receivedQuote.length > 0 ? (
                          receivedQuote.map((data) => (
                            <div key={data.id}
                              onClick={() => handleJobClick(data.id, data)}
                              style={{
                                border: getId === data.id ? '2px solid blue' : 'none', // Change border color if selected
                                borderRadius: getId === data.id ? '12px' : 'none', // Change border color if selected
                                cursor: 'pointer',
                              }}>
                              <ChatUser data={data} id={data.id} />
                            </div>
                          ))
                        ) : (
                          <p>No Message</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='view-chat-body-message' >

              <div className="chat-header">
                <div className='d-flex align-items-center'>
                  <img className='chat-header-image ms-2 me-3' src={UserIcon} alt="Not6ification" />
                  <p className='m-0 fs-4 fw-bolder'>{receivedQuoteItem?.business?.businessName}</p>
                </div>
                <div className='d-flex align-items-center'>
                  <img src={BellIcon} alt="Not6ification" />
                  <img src={SettingIcon} alt="Not6ification" />
                </div>
              </div>

              <div className="chat-message-container">

                {isLoading && <Loader2 />}
                {!isLoading && (
                  <div>
                    {messagesArray.length > 0 ? (
                      messagesArray.map((msg) => (
                        msg.type === 'sent' ? (
                          <SentMessage key={msg.id} message={msg.message} />
                        ) : (
                          <ReceivedMessage key={msg.id} message={msg.message} />
                        )
                      ))
                    ) : (
                      <p>No Message</p> // Render this when no jobs are available
                    )}
                  </div>
                )}


              </div>

              <div className='chat-input-div'>
                <div className="chat-input-container">
                  <img src={AddIcon} alt='Add' style={{ cursor: 'pointer' }} />
                  <div className='chat-input-box'>
                    <input type='text' value={inputValue} onChange={handleInputChange} placeholder='Type a message...' />
                    <div className='d-flex align-items-center'>
                      <img className='chat-input-box-img' src={TextIcon} alt='Add' />
                      <img className='chat-input-box-img' src={SmileIcon} alt='Add' />
                      <img className='chat-input-box-img' src={VoiceIcon} alt='Add' />
                      <img className='ms-2 me-2' onClick={SendMessageResponse} src={SendIcon} style={{ cursor: 'pointer' }} alt='Add' />
                    </div>
                  </div>
                </div>
                <span >{errorMsg}</span>
              </div>


            </div>

            <div className='chat-detail-content-div'>
              {isLoading && <Loader2 />}
              {!isLoading && (
                <div className='chat-detail-content'>

                  <div className='d-flex align-items-center'>
                    <img src={CompanyLogo} alt='comapny logo' style={{ height: '85px', width: '85px', marginRight: '10px' }} />
                    <p className='fs-4 fw-bolder m-0'>{receivedQuoteItem?.business?.businessName}</p>
                  </div>

                  <div className='mt-4'>
                    <p className="m-0">{receivedQuoteItem?.business?.overview}</p>
                    <RatingWhite stars={Math.round(receivedQuoteItem?.business?.overallRating || 0)} className="mb-4" />
                  </div>

                  <div className='d-flex align-items-center mt-4' >
                    <img src={locationIcon} alt='comapny logo' style={{ height: '30px', width: 'auto', marginRight: '10px' }} />
                    <p className="m-0">{receivedQuoteItem?.business?.streetNumber}  &nbsp;{receivedQuoteItem?.business?.streetName} &nbsp; {receivedQuoteItem?.business?.suburb} &nbsp;{receivedQuoteItem?.business?.country}</p>
                  </div>

                  <div className='d-flex align-items-center mt-4'>
                    <img src={locationIcon} alt='comapny logo' style={{ height: '30px', width: 'auto', marginRight: '10px' }} />
                    <div className='d-flex flex-column'>
                      <p className="m-0">Phone</p>
                      <p className="m-0 fs-4 fw-bolder">{receivedQuoteItem?.business?.phone}</p>
                    </div>
                  </div>

                  <div className='d-flex flex-column justify-content-center mt-4'>
                    <p className='chat-detail-button-white'>View Profile</p>
                    <p className='chat-detail-button-blue'>Hire for job</p>
                  </div>

                </div>
              )}
            </div>



          </div>
        </div>
      </div>
    </>
  )
}

export default TabBusinessResponse
